import React from "react";
import { HeaderWrapper } from "./HeaderStyle";
// import SearchIcon from "../../../../assets/icons/SearchIcon";
import Notifications from "./Notifications";
import SuperAdmin from "./SuperAdmin";
import { useDispatch, useSelector } from "react-redux";
import { setToggleMenu } from "../../redux/features/appMangerUtilitySlice";
import { UseAuthProvider } from "@bjsdistribution/tms-component-library";

// import NotificationPopup from "./NotificationPopup";

// org is decided by domain at login (see Login.tsx), so there is no Switch Client dropdown here
const Header = () => {
  const { userInfo } = UseAuthProvider();

  const dispatch = useDispatch();
  const { toggleMenu } = useSelector((state: any) => state.appMangerUtilitySlice);

  const toggleMenuFun = () => {
    dispatch(setToggleMenu(!toggleMenu));
  };

  return (
    <HeaderWrapper>
      <header id="header" className="flex-justify">
        <div className="filterData flex-item-center">
          <span className="menu" onClick={toggleMenuFun}>
            {!toggleMenu && (
              <>
                <i></i>
                <i></i>
                <i></i>
              </>
            )}
            {toggleMenu && (
              <div className="navButton">
                <span className="line1"></span>
                <span className="line2"></span>
                <span className="line3"></span>
              </div>
            )}
          </span>
          {/* <div className="textBoxWrapper">
            <input type="text" placeholder="Search for anything..."></input>
            <SearchIcon />
          </div> */}
        </div>
        <div className="rightPart flex-item-center">
          {/* <NotificationPopup /> */}
          {/* <Notifications /> */}
          <SuperAdmin userInfo={userInfo} />
          {/* <Setting /> */}
        </div>
      </header>
    </HeaderWrapper>
  );
};

export default Header;
